{
    "NewuserWelcomereporting": "Willkommen bei Akixi Reporting",
    "NewuserWelcometoreporting": "Willkommen bei der Berichterstattung",
    "NewuserLetsbegin": "Lass uns anfangen.",
    "NewuserStartTutorial": "Tutorial starten",
    "NewuserSkiptutorial": "Lernprogramm überspringen",
    "NewuserAddmodifyreport": "Berichte hinzufügen\/ändern...",
    "NewuserReportfiltering": "Berichtsfilterung...",
    "NewuserAddingfields": "Felder hinzufügen...",
    "NewuserReportquickchanges": "Schnelle Änderungen melden...",
    "NewuserFinish": "Fertig",
    "NewuserNext": "Nächste",
    "NewuserPrevious": "Vorherige",
    "NAME": "LanguageNewUserTutorial"
}